// extracted by mini-css-extract-plugin
export default {"page":"Print_page__y6Dd3","main":"Print_main__gAPzW"};